import { map } from 'lodash/fp';
import { createSelector } from 'reselect';
import { Option } from '@mews-commander/legacy-data-structures';
import { getRebateReasons } from '@mews-commander/legacy-entities/src/ducks/rebateReasons';

export const getRebateReasonsOptions = createSelector(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    getRebateReasons,
    map((reason) => Option({ value: reason, label: reason }))
);
